@if (translation) {
    <nz-layout class="app-layout">
        <nz-sider class="menu-sidebar" nzWidth="260px" [nzCollapsed]="isCollapsed">
            <div class="sidebar-logo">
                <a routerLink="/" nz-button nzType="link" nzBlock href="/">
                    @if (isCollapsed) {
                        <img src="/assets/ultra-mobile.svg" alt="u" />
                    } @else {
                        <img src="/assets/ultra.svg" alt="Ultra" />
                    }
                </a>
            </div>

            <app-navigation [isCollapsed]="isCollapsed" />
        </nz-sider>
        <nz-layout
            [class]="{
                layout: true,
                collapsed: isCollapsed,
            }"
        >
            <nz-header>
                <div class="app-header">
                    <nz-row nzJustify="space-between">
                        <nz-col [nzSpan]="24">
                            <button
                                class="header-toggle"
                                nz-button
                                nzType="text"
                                (click)="collapsedChanged()"
                            >
                                <nz-icon
                                    class="trigger"
                                    [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"
                                />
                            </button>

                            <button nzType="text" nz-button (click)="toggleTheme()">
                                <nz-icon
                                    class="theme-switcher"
                                    [nzType]="getThemeName() === 'dark' ? 'sun' : 'moon'"
                                />
                            </button>
                            <app-goto></app-goto>
                            &nbsp;
                            <nz-select
                                [(ngModel)]="currentLanguage"
                                (ngModelChange)="changeLanguage($event)"
                                ngModel="lucy"
                            >
                                <nz-option nzValue="ru" nzLabel="RU"></nz-option>
                                <nz-option nzValue="ro" nzLabel="RO"></nz-option>
                                <nz-option nzValue="en" nzLabel="EN"></nz-option>
                            </nz-select>

                            @if (fileManagerService.isOpen()) {
                                <app-file-manager-modal
                                    [isSelectable]="false"
                                    [isVisible]="true"
                                    (closeEvent)="closeFileManager()"
                                    [rememberLastState]="false"
                                ></app-file-manager-modal>
                            }
                        </nz-col>
                    </nz-row>
                </div>
            </nz-header>
            <nz-content>
                <div
                    [class]="{
                        'inner-content': true,
                        loading: loaderService.state(),
                    }"
                >
                    <router-outlet></router-outlet>
                    @if (loaderService.state()) {
                        <app-loader [contentLoader]="true" />
                    }
                </div>
            </nz-content>
        </nz-layout>
    </nz-layout>
}
